import React from 'react';
import { ModalCover as ModalCoverCore } from '@core-front/modal';
const ModalCover = (props) => React.createElement(ModalCoverCore, Object.assign({}, props));
export { ModalCover as default };
